module.exports = __webpack_public_path__ + "static/5-5d4c557b28af2cd36301d29ee6aafed9.jpg";